import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: grid;

  grid-auto-flow: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  cursor: pointer;
`

export const ColorBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const ColorBoxContainer = styled.div`
  position: relative;
  width: 39px;
  height: 27px;
  outline: 1px solid color-mix(in srgb, ${Colors.GS1000} 20%, transparent);
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAADFJREFUOE9jZGBgEGHAD97gk2YcNYBhmIQBgWSAP52AwoAQwJvQRg1gACckQoC2gQgAIF8IscwEtKYAAAAASUVORK5CYII=')
    left center;
  background-color: #ffffff;
`

export const CheckboxContainer = styled.div`
  padding: 16px;
  background-color: ${Colors.GS0};
  border: 1px solid ${Colors.GS500};
  border-top: none;
`
